const isAdmin = state => state.isAdmin;
const isWtAdmin = state => state.isWtAdmin;
const isNonAdmin = state => state.isNonAdmin;
const isWtAdminSuper = state => state.isWtAdminSuper;
const emailNotConfirmed = state => state.emailNotConfirmed;
const passwordChanged = state => state.passwordChanged;
const isTeamLeader = state => state.isTeamLeader;

export default {
  isAdmin,
  isWtAdmin,
  isWtAdminSuper,
  isNonAdmin,
  emailNotConfirmed,
  passwordChanged,
  isTeamLeader
};
